// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__e2R_D","col":"Table_col__19qdr","fulfillmentStatus":"Table_fulfillmentStatus__12Mdo","emailCol":"Table_emailCol__1zGww"};